import React, { Component } from 'react';
import { render } from 'react-dom';
import { createGlobalStyle } from 'styled-components';
import MediaQuery from 'react-responsive';
import WideScreenHero from './Slides/WideScreen/HeroSlide/Hero';
import WideScreenWork from './Slides/WideScreen/WorkSlide/Work';
import WideScreenSkills from './Slides/WideScreen/Skills';
import WideScreenContact from './Slides/WideScreen/ContactSlide/Contact';
import MobileHero from './Slides/Mobile/HeroSlide/Hero';
import MobileWork from './Slides/Mobile/WorkSlide/Work';
import MobileSkills from './Slides/Mobile/Skills';
import MobileContact from './Slides/Mobile/ContactSlide/Contact';
import './Assets/index.css';

const GlobalStyle = createGlobalStyle`
html, body { margin: 0; scroll-behavior: smooth; overflow-x:hidden; }
*, *:before, *:after { box-sizing: border-box; }
`;

class App extends Component {
  componentDidMount() {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }

  render() {
    return (
      <React.Fragment>
        {/* <MediaQuery query="(min-device-width: 1224px)"> */}
        <WideScreenHero />
        <WideScreenWork />
        <WideScreenSkills />
        <WideScreenContact />
        {/* </MediaQuery> */}
        {/* <MediaQuery query="(max-device-width: 1224px)">
          <MobileHero />
          <MobileWork />
          <MobileSkills />
          <MobileContact />
        </MediaQuery> */}
        <GlobalStyle />
      </React.Fragment>
    );
  }
}

render(React.createElement(App), document.getElementById('root'));
console.log(
  `%cGGGGGGGGGGGGGGGBBBBBGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG
GGGGGGGGGGGGGGPJ77?YGGGGGGGGGGGGPPPPPPPPPPPPPPPPPP
BBBBBBBBBBBBGJ:    .~5BBBBBBGGGGGGGGBBBBGGGGGGGGGG
BBBBBBBBBBBB7  ....  .5#BBBBBGGGBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBY:..^^::..~PBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBGY!^:^~~^::~!?5PGB#BBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBY~.:^^:.....::~?5BBBBBBBBBBBBBBBBB
GGGGGGGGGGGGGGGGBB?^^^^:...:.....!5BBBBBBBBBBBBBBG
GGGGGGGGGGGGGGGGGG7~~^^^:.........^?GGGGGGGGGGGGGG
GGGGGGGGGGGGGGGGGG?!~~^^:.........:^7GGGGGGGGGGGGG
PPPPPPPPPPPPPPPGPG57!^^^:..........:^7PGGGGGGGGGGG
PPPPPPPPPPPPPPPPPPP7~^^^::........:::^!PPPPPPPPPPP
555555555555PPPPPP5!~~^:::........!Y:^:?PPPPPPPPPP
555555555555555555Y!~^^:..........!P^:^7P555555555
YYYYYYYYYYYYYYYY5J~~^^^.........:.^5!::?5555555555
YYYYYYYYYYYYYYYY?~~^^!7:.........::?7.^JYYYYYYYYYY
JJJJJJJJJJJJJJJ!~^~!?Y?:...........~~.~YYYYYYYYYYY
JJJJJJJJJJJJJ7~^!7JJJJJ^............:::?JJJJJJJJJJ
????????????7!~7JJ????J^..........:::.:?JJJJJJJJJJ
????????????~~?????????~::^^^^^^^^!7!!?????????JJJ
7777777777777!77777?????7!77!~~~~^????????????????
7777777777777777777777777?77!~~~~7????????????????
7777777777777777777777777?77!~~~~!7777777777777777
777777!!!!!!!!!!!!!!!!!!!?77!~!~~!7777777777777777
!!!!!!!!!!!!!!!!!7777!!!^!777!~~~!7777777777777777
!!!!!!!!!!!77!!!!!!!!!!~::~!~~~^^~!!!!!!!!!!!!!!!!
!!!!!!!!!!!!!!!!!!!!!!!~^:^!~~~^^~!!!!!!!!!!!!!!!!
!!!~~~~~~!!!!!!!!!!!!!!~^:^!!~~~^^~!!!!!!!!!!!!!!!
~~~!!!!!!!!!7777!!!!!!!~::~!!!~~~^^~!!!~~~!!!!!!!!
~!!!!!!!!7!!!!!!!!~~~~~^:^~^^^^~~^^^^~~^~~~~~~~~~~
~~~~!!!!~~~!!!!!!~~^~^^^^^^^^^^^~^^:^~!~~!!~~~~~~~
~~~~!~~~~~~~~~~~~~~~~^^^^^~~^^^~~^^:^~~~~~~~~~!!!!
`,
  'color:#2CDB29;'
);
console.log('%cThis is me walking away after dropping the mic!', 'color: #2CDB29; font-size: 20px;');
console.log(
  '%c• If you have any constructive criticism I would love to hear from you! •',
  'color: #355E3B; font-size: 12px;'
);
// console.log(
//   `%c                 .^~!77???777!~:.
//             .^!?JJ??7!!~~~~!!7?JJJ?!:.
//          .^?YJ7~^::..::::::::..::^~7JY7^
//        .!YJ!^:.::::::::::::::::::::..^7YY!.
//      .!5J^.::::::...::^^~~~~^^::..:!^:.:~J5~
//     :YY^.:::::.:^7?JYYJJ?????JJJJJBY:.:::.~5J:
//    ^P?.::::.:!J5Y?!^::::.......!#BJYY~.:::::JP:
//   ^G7.:::.:?GP7^:.::::::::::::J@5:.:!P5^.:::.?P:
//  .P?.:::.!BG!..::::::::::::::P@J.:::.:J#!.:::.Y5.
// .7G::::.?@5:.:::::::::::::.^B@J.::::::.5@!:::::G~.
// .P?.:::~@#:::::::::::::::.^B@J.::::::::~@G::::.JY.
// :G~:::.!@&~.:::::..:^:::.^B@Y.:::::::::^&&^:::.7P.
// :G~:::::J&&Y!^^^~7JYJ^::^B@5:::::::::::~@&^:::.7P.
// .P7.::::.^JPP55YJ7~:::.^B@P:::::::::::.Y@G::::.JY.
//  7P.::::::..::::..:::.^B@P:::::::::::.!&@7.::::G!.
//  :G7.:::::::::::::::.!#@Y::::::::::..7&@?.:::.J5.
//   ^G!.::::::^^^::..:J@#7.:::::::..:!P@B!.:::.7G^
//    ~G7.::!YJ???JJ55B@5~:::::::^~7YB#P7:.:::.?P^
//     ^5Y^.JP777?J5PY7!7?JJJJYY555YJ!^..:::.^YY:
//      .75?::~!!~~^:.....:::::::::..:::::.^J5!.
//        .7YJ~:..::::::::::::::::::::..:!JY7.
//          .~JYJ!^::..::::::::::..::~7JY?~.
//             .^7?JJ?7!~~~^^~~!!7?JJ?!^.
//                 .:^!77??????7!~^:.
// `,
//   "color:#2CDB29;"
// );
// console.log("%cI knew you'd come here!!!", "color: white; font-size: 20px;");
// console.log(
//   "%cIf you have any constructive criticism I would love to hear from you!",
//   "color: #355E3B; font-size: 12px;"
// );
